module.exports = fp;


//////////////////
// WEBPACK FOOTER
// external "fp"
// module id = 2
// module chunks = 0